import React from "react";
import { Dropdown } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useLanguageContext } from "../i18n/LanguageContext";
import { FaGlobe } from "react-icons/fa";
import { Icon } from "./common/Icon";

const LanguageDropdown: React.FC = () => {
  const { i18n, t } = useTranslation();
  const { setLanguage } = useLanguageContext();

  const currentLang = i18n.language;

  const languages = [
    { code: "tr", name: "Türkçe", flag: "🇹🇷" },
    { code: "en", name: "English", flag: "🇬🇧" },
  ];

  const currentLangData = languages.find(l => l.code === currentLang) || languages[1];

  const handleSelect = (lang: string | null) => {
    if (lang) {
      setLanguage(lang);
    }
  };

  return (
    <Dropdown align="end" onSelect={handleSelect} className="modern-lang-dropdown">
      <Dropdown.Toggle 
        variant="link" 
        id="language-dropdown" 
        className="d-flex align-items-center gap-2 px-3 py-2 text-decoration-none border rounded-pill transition-all"
        aria-label={t("language.title")}
      >
        <div className="lang-icon-wrapper">
          <Icon icon={FaGlobe} size={14} className="text-primary" />
        </div>
        <span className="lang-code text-uppercase fw-bold text-dark">{currentLang}</span>
        <span className="lang-flag-preview">{currentLangData.flag}</span>
      </Dropdown.Toggle>

      <Dropdown.Menu className="border-0 shadow-lg mt-2 py-2 rounded-4 animate-fade-in">
        <div className="dropdown-header px-3 pb-2 text-muted small text-uppercase ls-1">
          {t("language.select") || "Select Language"}
        </div>
        {languages.map((lang) => (
          <Dropdown.Item 
            key={lang.code}
            eventKey={lang.code} 
            active={currentLang === lang.code}
            className={`px-3 py-2 d-flex align-items-center gap-3 transition-all ${currentLang === lang.code ? 'bg-primary-subtle' : ''}`}
          >
            <span className="fs-5">{lang.flag}</span>
            <div className="d-flex flex-column">
              <span className={`fw-semibold ${currentLang === lang.code ? 'text-primary' : 'text-dark'}`}>
                {lang.name}
              </span>
              {currentLang === lang.code && (
                <span className="text-primary x-small fw-medium">Active</span>
              )}
            </div>
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default LanguageDropdown;


